import { useEffect, Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import AdventuresSlider from './AdventuresSlider'
import useNearByActivites from './hooks/useNearByActivities'

export default function ActivitesNearBy({ activityId, coords, showAllOnFail }) {
  const { items, isLoading, nothingFound } = useNearByActivites({
    activityId,
    type: 'conservation',
    coords,
    showAllOnFail,
  })
  useEffect(() => {
    if(!isLoading && !items.length) {
      const parent = document.getElementById('nearby-parent')
      if(parent) {
        parent.setAttribute('hidden', true)
      }
    }
  }, [isLoading])

  return (
    <Fragment>
      {nothingFound && !isLoading && (
        <span className='activities-not-found'>
          <FormattedMessage
            id='activities.not-found'
            defaultMessage='We couldn’t find any activities near you, but you might like these options.'
          />
        </span>
      )}
      <AdventuresSlider items={items} isLoading={isLoading} isConservation />
    </Fragment>
  )
}
